


















































































import { Component, Vue, PropSync, Prop } from "vue-property-decorator"
import { ORDER_BY_DIRECTION_LIST } from '@/constants/filter'
import { STATUSES, TYPES_DISPLAY, PAYMENT_METHODS } from '@/constants/booking'
import _ from 'lodash'
import { mapState } from "vuex"

@Component({
  computed: {
    ...mapState('Business', {
      allBusinesses: "allBusinesses",
    }),
  },
})
export default class BookingListFilterChip extends Vue {
  @PropSync('options') optionsSynced!: BookingListFilterOptions
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly loading!: boolean;

  statuses = STATUSES
  typesDisplay = TYPES_DISPLAY
  paymentMethods = PAYMENT_METHODS
  directionList = ORDER_BY_DIRECTION_LIST

  optionsLocal!: BookingListFilterOptions
  allBusinesses!: Model[]

  orderByList = [
    {
      text: 'Object ID',
      value: 'object_id',
    },
    {
      text: 'Created At',
      value: 'created_at',
    },
    {
      text: 'Update At',
      value: 'updated_at',
    },
  ]

  isMounted = false

  mounted() {
    this.optionsLocal = _.cloneDeep(this.optionsSynced)
    this.isMounted = true
  }

  orderByName (value) {
    const name = this.orderByList.find(item => item.value === value)
    if (name) {
      return name.text
    }
    return ''
  }

  directionName (value) {
    const name = this.directionList.find(item => item.value === value)
    if (name) {
      return name.text
    }
    return ''
  }

  StatusesName() {
    let text = ''
    if (this.optionsSynced.statuses) {
      for (let i = 0; i < this.optionsSynced.statuses?.length; i++) {
        if (i > 0) {
          text += ', '
        }
        text += this.statuses[this.optionsSynced.statuses[i]]['value']
      }
    }
    return text
  }

  directionIcon () {
    if (this.optionsSynced.orderByDirection == 'asc') {
      return 'mdi-sort-ascending'
    } else {
      return 'mdi-sort-descending'
    }
  }

  businessName() {
    return this.allBusinesses.find((item) => item.object_id == this.optionsSynced.businessOid)?.name
  }

  closeQuery () {
    this.optionsSynced.query = null
  }

  closeSort () {
    this.optionsSynced.orderBy = null
  }

  closeStatus () {
    this.optionsSynced.statuses = []
  }

  closeType () {
    this.optionsSynced.type = null
  }

  closeCandidateName () {
    this.optionsSynced.candidateName = null
  }

  closeBusinessOid () {
    this.optionsSynced.businessOid = null
  }

  switchOrderByDirection() {
    if (this.optionsSynced.orderByDirection == 'asc') {
      this.optionsSynced.orderByDirection = 'desc'
      // this.directionIcon = 'mdi-sort-descending'
    } else {
      this.optionsSynced.orderByDirection = 'asc'
      // this.directionIcon = 'mdi-sort-ascending'
    }
  }

}
